module.exports = __webpack_public_path__ + "img/bulldog_bg.6005e881.jpg";